import { atom } from 'recoil';

export const unreadNotificationsAtom = atom({
    key: 'unreadNotifications',
    default: 0,
});
